import React, {createContext, useState} from "react";
import useGlobeSettings from "lib/helpers/globeview/useGlobeSettings";
import PropTypes from "prop-types";

export const GlobeState = createContext("");

export const GlobeProvider = ({children}) => {
    // this is for reading the satellite orbit data only,
    // setting it does not affect the actual orbits
    const [satOrbits, setSatOrbits] = useState({});
    const [allGroundstations, setAllGroundstations] = useState([]);
    const [sunPosition, setSunPosition] = useState(null);

    const {
        showFuture,
        trackSat,
        hiddenSatellites,
        showConstellationGrid,
        showOverpassTable,
        showGroundTrack,
        showAxis,
        showSAA,
        cadModelIndex,
        telemCatIndex,
        telemCats,
        relSatTelem,
        showAllContacts,
        currentTab,
        setCadModelIndex,
        setShowFuture,
        setTrackSat,
        setHiddenSatellites,
        isConstellationShowing,
        setShowConstellationGrid,
        setShowOverpassTable,
        setShowGroundTrack,
        setShowAxis,
        setShowSAA,
        setTelemCatIndex,
        setTelemCats,
        setRelSatTelem,
        setShowAllContacts,
        setCurrentTab,
    } = useGlobeSettings();

    const globe = {
        /* STATES */
        showFuture,
        trackSat,
        hiddenSatellites,
        showConstellationGrid,
        showOverpassTable,
        showGroundTrack,
        showAxis,
        showSAA,
        cadModelIndex,
        telemCatIndex,
        telemCats,
        relSatTelem,
        showAllContacts,
        currentTab,
        satOrbits,
        allGroundstations,
        sunPosition,

        /* SETTERS */
        setShowFuture,
        setTrackSat,
        setHiddenSatellites,
        isConstellationShowing,
        setShowConstellationGrid,
        setShowOverpassTable,
        setShowGroundTrack,
        setShowAxis,
        setCadModelIndex,
        setShowSAA,
        setTelemCatIndex,
        setTelemCats,
        setRelSatTelem,
        setShowAllContacts,
        setCurrentTab,
        setSatOrbits,
        setAllGroundstations,
        setSunPosition,
        /* EFFECTS */
    };

    return (
        <GlobeState.Provider value={{globe}}>{children}</GlobeState.Provider>
    );
};

GlobeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default GlobeProvider;
